<template>
  <div class="new-vehicle">
    <page-header
      title="Update Status"
      breadcrumb="Dashboard > Bookings & Shipments  > bookings"
    />

    <div class="custom-card">
      <div class="mt-3 container-fluid">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Shipping Ref.</label>
            <input
              type="text"
              class="input"
              disabled
              v-model="booking.shippingReference"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Fleet ID</label>
            <input
              type="text"
              class="input"
              disabled
              v-model="booking.fleet.fleetReference"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Consignee</label>
            <input
              type="text"
              class="input"
              disabled
              v-model="booking.consigneelocation.contactName"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Shipper</label>
            <input
              type="text"
              class="input"
              disabled
              v-model="booking.shipperlocation.contactName"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Start Date & Time</label>
            <el-date-picker
              disabled
              v-model="booking.sourcePickupTime"
              type="datetime"
              placeholder="Select date and time"
              default-time="12:00:00"
            >
            </el-date-picker>
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">End Date & Time</label>
            <el-date-picker
              disabled
              v-model="booking.destinationPickupTime"
              type="datetime"
              placeholder="Select date and time"
              default-time="12:00:00"
            >
            </el-date-picker>
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Name of Official</label>
            <input disabled v-model="username" type="text" class="input" />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Role of Official</label>
            <input type="text" class="input" value="admin" />
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Current Status</label>
            <el-select v-model="activityType" placeholder="Select Country">
              <el-option
                v-for="country in statusArray"
                :key="country"
                :label="country"
                :value="country"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label flex justify-between m-2">
              <div class="flex gap-4 items-center">
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5551 2.89598C19.3147 2.77012 19.0177 2.77012 18.7774 2.89598C17.8467 3.3623 16.7981 3.60478 15.733 3.6C14.1762 3.63098 12.6709 3.09773 11.5553 2.12002C10.2674 0.985406 8.5261 0.365438 6.72431 0.400031C5.27324 0.388734 3.85452 0.785906 2.66662 1.53605V1.2C2.66662 0.537281 2.0697 0 1.33331 0C0.596917 0 0 0.537234 0 1.2V22.8C0 23.4627 0.596917 24 1.33331 24C2.06965 24 2.66662 23.4628 2.66662 22.8V12.4C2.81391 12.3876 2.95422 12.3376 3.07104 12.256C4.12842 11.5552 5.41126 11.1844 6.72431 11.2C8.28397 11.1677 9.79254 11.701 10.9109 12.68C12.1963 13.8129 13.9342 14.4328 15.7331 14.4C17.1116 14.4144 18.4638 14.0594 19.6174 13.38C19.8643 13.226 20.0081 12.9702 19.9996 12.6999V3.6C20.0041 3.31022 19.834 3.04087 19.5551 2.89598ZM1.77768 22.8C1.77768 23.0209 1.57872 23.2 1.33326 23.2C1.08779 23.2 0.888839 23.0209 0.888839 22.8V1.2C0.888839 0.979078 1.08779 0.800016 1.33326 0.800016C1.57872 0.800016 1.77768 0.979078 1.77768 1.2V22.8ZM19.1107 12.716C18.1045 13.3005 16.9305 13.6078 15.733 13.6C14.1762 13.631 12.6709 13.0978 11.5553 12.12C10.2674 10.9854 8.5261 10.3655 6.72431 10.4001C5.27418 10.3861 3.85545 10.7805 2.66662 11.5281V2.568C3.7766 1.66406 5.22767 1.17488 6.72431 1.2C8.28397 1.16775 9.79254 1.70105 10.9109 2.67998C12.1963 3.81295 13.9342 4.43283 15.7331 4.39997C16.91 4.40737 18.0706 4.15172 19.1108 3.65597V12.716H19.1107Z"
                    fill="#10233E"
                  />
                  <path
                    d="M15.768 8.9006C15.7306 8.76968 14.8106 5.68885 12.0669 4.77641C9.7126 3.99346 6.80374 5.78503 6.6809 5.86179C6.59736 5.91414 6.56278 6.02025 6.59909 6.11288C6.6528 6.24835 7.93972 9.43528 10.294 10.2182C12.6483 11.0012 15.5572 9.2096 15.68 9.13284C15.7572 9.08442 15.7937 8.98929 15.768 8.9006ZM10.4207 9.82953C8.53333 9.20188 7.33528 6.77432 7.04277 6.12129C7.66137 5.77084 10.0503 4.53658 11.9403 5.16512C14.1486 5.89953 15.1117 8.24596 15.3315 8.86617C14.7339 9.20551 12.324 10.4625 10.4207 9.82953Z"
                    fill="#10233E"
                  />
                  <path
                    d="M11.6867 5.94241C10.8437 5.66207 9.93102 6.13141 9.65167 6.98888C9.37232 7.84635 9.83067 8.77166 10.6736 9.052C11.5166 9.33234 12.4293 8.86299 12.7087 8.00553C12.988 7.14806 12.5297 6.22275 11.6867 5.94241ZM10.8003 8.66332C10.1682 8.45313 9.82434 7.75888 10.0338 7.11598C10.2432 6.47307 10.928 6.12093 11.5601 6.33112C12.1921 6.54131 12.536 7.23556 12.3266 7.87847C12.1171 8.52137 11.4323 8.87351 10.8003 8.66332Z"
                    fill="#10233E"
                  />
                </svg>
                <span>Visibility Flag</span>
              </div>
              <el-tooltip placement="top">
                <div slot="content">Choose who can view updates</div>
                <span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0V0Z"
                      fill="#383F51"
                    />
                  </svg>
                </span>
              </el-tooltip>
            </label>
            <div class="route-type-options">
              <div class="single-option">
                <label for="inter-state" class="radio-label label">
                  <input type="radio" id="inter-state" value="all" />
                  All
                  <span></span>
                </label>
              </div>
              <div class="single-option">
                <label for="intra-state" class="radio-label label">
                  <input type="radio" id="intra-state" value="users" />
                  Users
                  <span></span>
                </label>
              </div>
              <div class="single-option">
                <label for="last-mile" class="radio-label label">
                  <input type="radio" id="last-mile" value="customers" />
                  Customers
                  <span></span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-12">
            <label class="label">Comment</label>
            <textarea
              name=""
              v-model="message"
              id=""
              cols="30"
              rows="30"
              class="input "
              style="height: 8rem;"
            ></textarea>
            <span class="limiter">{{ charactersLeft }}</span>
          </div>
        </div>
        <div class="flex my-8 justify-between">
          <p class="cursor-pointer" @click="$router.go(-1)">Back</p>
          <base-button
            @click="updatebookingStatus"
            :loading="loading"
            text="update"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      loading: false,
      shippingId: "",
      activityType: "on_delivery",
      message: "",
      statusArray: [
        "inTransit",
        "processing",
        "delayed",
        "canceled",
        "pending",
        "fleet_sche",
        "dropped_of",
        "declined",
        "picked_up",
        "assigned",
        "unassigned",
        "loading",
        "on_deliver",
      ],
      booking: {
        shippingReference: "",
        fleet: {
          fleetReference: "",
        },
        consigneelocation: {
          contactname: "",
        },
        shipperlocation: {
          contactname: "",
        },
        sourcePickupTime: "",
        destinationPickupTime: "",
      },
    };
  },
  computed: {
    // booking(){
    //   const ship = localStorage.getItem("booking")
    //   return ship ? JSON.parse(ship) : {}
    // },
    username() {
      return (
        this.$store.getters.user.firstname +
        " " +
        this.$store.getters.user.firstname
      );
    },
    charactersLeft() {
      var char = this.message.length,
        limit = 300;
      return limit - char + " / " + limit;
    },
  },
  mounted() {
    this.activityType = this.booking.deliveryStatus;
  },
  methods: {
    updateShippingStatusByDriver() {
      // this.$_updateShippingStatusByDriver(this.getShippment);
    },
    async updatebookingStatus() {
      this.loading = true;
      try {
        let response = await this.$_shippingActivityLogs({
          shippingId: this.booking.id,
          activityType: this.activityType,
          message: this.message,
        });
        console.log(response);
        this.loading = false;
        this.generateToast("booking Updated!", "success");
        this.$router.push({ name: "booking" });
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.route-type {
  display: flex;
  flex-wrap: wrap;
  p {
    padding-right: 2rem;
  }
}
.route-type-options {
  display: flex;
  flex-wrap: wrap;
  .single-option {
    padding-right: 1.5rem;
  }
}
</style>
